import { OfferingAndPricingPlan } from '../types';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { PricingPlanType } from '@atlassian/cssxp-typescommon';

export const getPricingPlanId = ({
  initialOfferingId,
  initialPricingPlanId,
  enableRetainPricingPlan,
  entitlementPriceEligibility,
  pricingPlanType,
  offerings,
  offeringId,
  currency,
  pricingEligibility,
  defaultPricingEligibilityToCommercial,
}: {
  initialOfferingId: string;
  initialPricingPlanId: string;
  enableRetainPricingPlan: boolean;
  entitlementPriceEligibility?: string;
  pricingPlanType?: string;
  offerings?: OfferingAndPricingPlan[];
  offeringId?: string; // This is final offeringId of the product
  currency?: `${generatedTypesNew.Currency}`;
  pricingEligibility?: `${PricingPlanType}`;
  defaultPricingEligibilityToCommercial?: boolean;
}): string => {
  if (!offerings || !offeringId || !currency || !pricingEligibility) return '';
  const currentOffering = offerings.find((offering) => offering.id === offeringId);
  if (!currentOffering) return '';

  /**
   * if(
   * Retain Pricing Plan is enabled &&
   * Source price eligibility === Destination price eligibility &&
   * Edition of entitlement is not Changed &&
   * Product pricing plan type is not default pricing plan type
   * ==> Same Pricing plan id will be set which came intially for the product.
   *
   * Else for all cases default pricing based on price eligibility will be set.
   */
  if (
    enableRetainPricingPlan &&
    pricingPlanType &&
    entitlementPriceEligibility &&
    initialOfferingId === offeringId &&
    entitlementPriceEligibility === pricingEligibility &&
    pricingPlanType !== 'DEFAULT_PRICING'
  ) {
    return initialPricingPlanId;
  }

  const pricingPlan = currentOffering.pricingPlans?.find(
    (p) => p.currency === currency && p.type.toUpperCase() === pricingEligibility.toUpperCase()
  );

  /**
   * If pricing plan in destination Billing profile is not supported for product
   * and defaultPricingEligibilityToCommercial is true,
   * then return the commercial pricing plan id.
   *
   * For Eg, if the destination Billing profile is selected as 'Open Source' and
   * the product (Say Loom) does not support 'Open Source' pricing plan,
   * then return the 'Commercial' pricing plan id.
   */
  if (!pricingPlan && defaultPricingEligibilityToCommercial) {
    return (
      currentOffering.pricingPlans?.find(
        (p) => p.currency === currency && p.type.toUpperCase() === PricingPlanType.COMMERCIAL
      )?.id ?? ''
    );
  }

  if (!pricingPlan) return '';

  return pricingPlan.id ?? '';
};
